import { createAction, props } from '@ngrx/store';


export const workOrderCustomDatesIntervalTicked = createAction(
  '[DOMAIN: Custom Dates] (Work Order Custom Dates Interval) Ticked',
  props<{ entityKey: string }>(),
);
